/* eslint-disable unicorn/filename-case */

/* eslint-disable react/jsx-no-literals */

import { useValidation } from '@xengage/gw-portals-validation-react';
import { BreakpointTrackerContext } from '@jutro/layout'
import { useDataRefresh, ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { WizardPage, wizardProps } from '@xengage/gw-portals-wizard-react';
import _ from 'lodash';
import React, { useCallback, useContext, useMemo, useState, useEffect } from 'react';
import { TranslatorContext } from '@jutro/locale';
import UWCompanyUtil from '../../utils/UWCompanyUtil_TWIA.js';
import AgentRegistrationWizardTemplate from '../../templates/AgentRegistrationWizardTemplate';
import metadata from './EFTPaymentInfo.metadata.json5';
import styles from './EFTPaymentInfo.module.scss';




function EFTPaymentInfo(props) {
  const { wizardData: registrationVM, updateWizardData, id, isConfirmationPage } = props;
  const { refreshData } = useDataRefresh();
  const breakpoint = useContext(BreakpointTrackerContext);
  const [showErrors, setShowErrors] = useState(false);
  const translator = useContext(TranslatorContext);
  const { onValidate, isComponentValid } = useValidation(id);
  const isTWIA = UWCompanyUtil.isTWIACompany(_.get(registrationVM, 'uwcompany'));
  // Fix for DE15245
  const [isAccountNumberPresent, setIsAccountNumberPresent] = useState(false);
  const isMailingAddressAvailable = _.get(registrationVM, 'hasMailingAddress.value');

  function paymentForm() {
    return (<div>
      <p className="eftInfo" style={{ textAlign: "center", color: 'green', fontWeight: 'bolder' }}>ELECTRONIC FUNDS TRANSFER TERMS AND CONDITIONS</p>
      <p>This document covers you and your rights and responsibilities concerning the Electronic Payment via electronic funds
        transfer ("EFT") services offered to you by Texas Windstorm Insurance Association (“TWIA”). Electronic funds transfers
        are electronically initiated transfers of money from your account through the electronic funds transfer services
        described below. By signing a request for EFT service, or using the service, each of you, jointly and severally, agree to
        the terms and conditions in the Agreement and any amendments for the EFT services offered.</p><br />
      <ol>
        <li><b>Definitions</b><br />
          In this Agreement, the words “you” and “yours” mean those who sign the application, joint owners, or any authorized
          users. The words “we,” “us,” and “our” mean TWIA. The word “account” means any one or more savings and checking
          accounts you have with banking institutions. Business day means Monday through Friday excluding any holidays on
          which TWIA and/or our third-party financial institution is closed.<br /><br />
        </li>
      </ol>
      <ol start="2">
        <li><b>Service Provider</b><br />
          You authorize TWIA to use a third-party to make the authorized EFT withdrawals.<br /><br />
        </li>
      </ol>
      <ol start="3">
        <li><b>EFT Services</b><br />
          Upon approval, you may use EFT services offered by TWIA. We will only process payments to TWIA. Our bank will
          withdraw, via the Automated Clearing House (ACH), the designated funds from the checking or savings account that
          you have specified. <br />
          Payment transactions requested on or before 8:00 pm Central Time will be processed the same day they are
          submitted. Payment transactions requested after 8:00 pm Central Time will be processed the following Federal
          business day.<br />
          If you’ve established Automated Clearing House Blocks at your bank for the bank accounts you intend to use you will
          need to define an ACH Filter at your bank for TWIA transactions.<br /><br />
        </li>
      </ol>
      <ol start="4">
        <li><b>Conditions of EFT Services</b><br />
          <u>Security of Access Code:</u> Your users will be using an access code (PIN and/or password) in conjunction with your
          electronic funds transfers. Access codes are confidential and should not be disclosed to third parties. You are
          responsible for safekeeping of your access code(s). You agree not to disclose or otherwise make your access code(s)
          available to anyone not authorized to sign on your accounts. You understand that any joint owner you authorize to
          use an access code may withdraw or transfer funds from any of your accounts. If you fail to maintain the security of
          these access codes and TWIA suffers a loss, we may terminate your EFT services immediately.<br />
          <u>Joint Accounts:</u> If any of your accounts accessed under this Agreement are joint accounts, all joint owners, including
          any authorized users, shall be bound by this Agreement and alone and together, shall be responsible for all EFT
          transactions to or from any savings or checking accounts, as provided in this Agreement. Each joint account owner,
          without the consent of any other account owner, may, and hereby is authorized by every other joint account owner
          to make any transaction permitted under this Agreement.<br /><br />
        </li>
      </ol>
      <ol start="5">
        <li><b>Fees and Charges</b><br />
          TWIA does not charge fees to you for this service. Your financial institution may charge fees to you for electronic funds
          transfers.<br /><br />
        </li>
      </ol>
      <ol start="6">
        <li><b>Agency Liability</b><br />
          You are responsible for all transactions you authorize using your EFT services under this Agreement. If you permit
          someone else to use an EFT service, you are responsible for any transactions they authorize or conduct on any of your
          accounts. If your bank statement shows transfers that you did not make, you must immediately notify TWIA and your
          bank<br /><br />
        </li>
      </ol>
      <ol start="7">
        <li><b>Right to Receive Documentation</b><br />
          You will receive a payment confirmation at the time you pay for TWIA insurance application, which you should print
          for your records. A copy of the confirmation will also accompany the completed insurance application you receive
          from TWIA.<br /><br />
        </li>
      </ol>
      <ol start="8">
        <li><b>Account Information Disclosure</b><br />
          We will only disclose information to third parties about your account or the transfers you make:<br />
          <ul>
            <li>As necessary to complete transfers;</li>
            <li>To comply with government agency or court orders; or</li>
            <li>If you give us written permission.</li>
          </ul>
        </li>
      </ol>
      <ol start="9">
        <li><b>Notices</b><br />
          All notices from TWIA will be effective when we have mailed them or delivered them to your last known address in
          TWIA’s records. Notices from you will be effective when received by TWIA at the address specified in this Agreement.
          We reserve the right to change the terms and conditions upon which this service is offered. We will mail notice to you
          at least twenty-one (21) days before the effective date of any change. Use of this service is subject to existing
          regulations governing the TWIA business relationship and any future changes to those regulations.<br /><br />
          Texas Windstorm Insurance Association<br />
          PO Box 99090<br />
          Austin, Texas 78709<br /><br />
          You will receive email communication from TWIA and TWIA’s bank regarding various aspects of the EFT service. As
          EFT payment service is inherently an electronic medium, you consent to the use of email as the mechanism TWIA and
          TWIA’s bank will use to communicate information regarding your enrollment and transactions. It is essential that your
          email address at TWIA and TWIA’s bank be kept current. All email notices from TWIA will be effective when we have
          sent them to your last known email address in TWIA’s records.<br /><br />
        </li>
      </ol>
      <ol start="10">
        <li><b>Termination of EFT Services</b><br />
          You may terminate this Agreement or any EFT service under this Agreement at any time by notifying us in writing and
          stopping your use of the service. TWIA may also terminate this Agreement at any time by notifying you orally or in
          writing. Whether you or TWIA terminates this Agreement, the termination shall not affect your obligations under this
          Agreement for any EFT transactions made prior to termination.<br /><br />
        </li>
      </ol>
      <ol start="11">
        <li><b>Governing Law</b><br />
          This Agreement is governed by the TWIA Plan of Operation (28 TAC §5.4001), federal laws and regulations, the laws
          and regulations of the State of Texas, and local clearinghouse rules, as amended from time to time. Any disputes
          regarding this Agreement shall be subject to the jurisdiction of the court of the county in which TWIA is located.<br /><br />
        </li>
      </ol>
      <ol start="12">
        <li><b>Enforcement</b><br />
          You are liable to us for any loss, cost or expenses we incur resulting from your failure to follow this Agreement. You
          authorize us to deduct any such loss, costs or expenses from amounts owed to you by TWIA without prior notice to
          you. If we bring legal action to collect any amount due under or to enforce this Agreement, we shall be entitled,
          subject to applicable law, to payment of reasonable attorney’s fees and costs, including fees on any appeal,
          bankruptcy proceedings, and any post-judgment collection actions.<br /><br />
        </li>
      </ol>
    </div>)
  }

  useEffect(() => {
    if (!registrationVM.agentEFTDTO_TWIA || !registrationVM.agentEFTDTO_TWIA.firstName.value) {
      registrationVM.agentEFTDTO_TWIA.firstName = registrationVM.agencyContact.firstName;
      registrationVM.agentEFTDTO_TWIA.lastName = registrationVM.agencyContact.lastName;
      registrationVM.agentEFTDTO_TWIA.telephone = registrationVM.agencyContact.telephone;
      registrationVM.agentEFTDTO_TWIA.email = registrationVM.email;

      updateWizardData(registrationVM);
    }
  }, []);

  const handleAccountNumberChange = useCallback((value) => {
    setIsAccountNumberPresent(!!value);
  }, []);

  const getUSStateList = useMemo(() => {
    const stateTypelist = registrationVM.agentEFTDTO_TWIA.mailingAddress.state.aspects.availableValues.map((code) => ({
      code: code.code,
      name: translator({ id: code.name })
    }))

    return stateTypelist
  }, [registrationVM, translator]);

  useEffect(() => {
    if (!isConfirmationPage) {
        const myInput = document.getElementsByName('confirmAccountNumber');

        myInput[0].onpaste = () => false;
    }
}, [isConfirmationPage]);


  const writeValue = useCallback(
    (value, path) => {
      if (path.includes("isCommercialAccount") && value === true) { // DE15279 do not default personal
        _.set(registrationVM, "agentEFTDTO_TWIA.isSavings", false);

      }

      _.set(registrationVM, path, value)
      updateWizardData(registrationVM);
      refreshData();
    },
    [refreshData, registrationVM, updateWizardData]
  );

  const getMailingAddressFields = useCallback(() => {
    if (!isMailingAddressAvailable) {
      return undefined;
    }
    const basePath = 'mailingAddress';
    return {
      addressLine1: { value: _.get(registrationVM.value, `${basePath}.addressLine1`) },
      addressLine2: { value: _.get(registrationVM.value, `${basePath}.addressLine2`) },
      addressLine3: { value: _.get(registrationVM.value, `${basePath}.addressLine3`) },
      city:         { value: _.get(registrationVM.value, `${basePath}.city`) },
      state:        { value: _.get(registrationVM.value, `${basePath}.state`) },
      zipCode:      { value: _.get(registrationVM.value, `${basePath}.postalCode`) },
    };
  }, [registrationVM]);

  const overrideProps = {
    '@field': {
      labelPosition: breakpoint === 'desktop' ? 'left' : 'top',
      showErrors,
      showRequired: true,
      readOnly: isConfirmationPage
    },
    eftPaymentsForm: {
      content: paymentForm()
    },
    tfpaRegistrationInstruction: {
      visible: !isTWIA && !isConfirmationPage,
    },
    twiaRegistrationInstruction: {
      visible: isTWIA && !isConfirmationPage,
    },
    clickNext: {
      visible: !isConfirmationPage
    },
    eftTermsAndConditions: {
      visible: !isConfirmationPage
    },
    eftConsentContainer: {
      visible: !isConfirmationPage
    },
    state: {
      showRequired: true,
      availableValues: getUSStateList,
      value: _.get(registrationVM.value, 'agentEFTDTO_TWIA.mailingAddress.state')
    },
    // DE15245 Set checkbox required based on Account Number and defaulting Account Type to checking
    tncField: {
      required: isAccountNumberPresent
    },
    accountType: {
      disabled: _.get(registrationVM.value, 'agentEFTDTO_TWIA.isCommercialAccount')
    },
    ...getMailingAddressFields()
  };

  const resolvers = {
    resolveClassNameMap: styles
  }

  const onNext = useCallback(async () => {
    if (!isComponentValid) {
      setShowErrors(true)

      return false
    }

    return registrationVM
  }, [isComponentValid, registrationVM])


  return (
    isConfirmationPage ?
      <ViewModelForm
        uiProps={metadata.pageContent}
        model={registrationVM}
        onModelChange={updateWizardData}
        overrideProps={overrideProps}
        classNameMap={resolvers.resolveClassNameMap}
        callbackMap={resolvers.resolveCallbackMap}
        componentMap={resolvers.resolveComponentMap}
        onValidationChange={onValidate}
        onValueChange={writeValue}
      /> :
      <WizardPage
        id={id}
        template={AgentRegistrationWizardTemplate}
        showNext={!_.isUndefined(_.get(registrationVM, 'agentEFTDTO_TWIA.acceptTerms'))}
        showCancel={!_.isUndefined(_.get(registrationVM, 'agentEFTDTO_TWIA.acceptTerms'))}
        onNext={onNext}
      >
        <ViewModelForm
          uiProps={metadata.pageContent}
          model={registrationVM}
          onModelChange={updateWizardData}
          overrideProps={overrideProps}
          classNameMap={resolvers.resolveClassNameMap}
          callbackMap={resolvers.resolveCallbackMap}
          componentMap={resolvers.resolveComponentMap}
          onValidationChange={onValidate}
          onValueChange={writeValue}
        />
      </WizardPage>
  )
}

EFTPaymentInfo.propTypes = wizardProps;
export default EFTPaymentInfo;
